<template>
  <el-dialog :visible.sync="visible" :title="'学生角色关联'" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="关联角色" prop="roleId">
        <el-select v-model="dataForm.roleId"  placeholder="请选择">
          <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" @change="changeSchoolHandle()">
          <el-option v-for="school in schoolList" :value="school.id" :label="school.schoolName" :key="school.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <span style="color: red">说明:角色需要各个学校的管理员创建的，否则会造成角色无法获取。</span>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      roleList: [],
      schoolVisible: false,
      schoolList: [],
      dataForm: {
        roleId: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        roleId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        Promise.all([
          this.getRoleList()
        ]).then(() => {
          this.getInfo()
        })
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/student/role/getValue?schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (res.code === 10050) {
            this.schoolVisible = true
            this.getSchoolList()
          }
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      })
    },
    getRoleList () {
      return this.$http.get('/sys/role/list').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.roleList = res.data
      }).catch(() => {})
    },
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      })
    },
    changeSchoolHandle () {
      this.getInfo()
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post(`/student/role?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
